<!-- 碧水湾-开门记录 -->
<template>
  <div class="mainArea COpenLog">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="openCost flex">
        <div>开门费用：{{openCost}}（元）</div>
        <div class="editIcon el-icon-edit-outline" @click="openCostDio"></div>
      </div>
      <div class="mainBodyContent">
        <el-table
          :data="openLogList"
          stripe
          style="width: 100%">
          <el-table-column
            label="费用(元)"
            width="180">
            <template slot-scope="scope">
              <span>{{ scope.row.payMoney/100 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="付费成功"
            width="180">
            <template slot-scope="scope">
              <div v-if="scope.row.paySuccess ===true">是</div>
              <div v-if="scope.row.paySuccess ===false">否</div>
            </template>
          </el-table-column>
          <el-table-column
            label="开门成功">
            <template slot-scope="scope">
              <div v-if="scope.row.openSuccess ===true">是</div>
              <div v-if="scope.row.openSuccess ===false">否</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="lastUpdateTime"
            label="时间"
            width="180">
          </el-table-column>
        </el-table>
        <!--分页组件-->
        <div class="page">
          <el-pagination
            layout="prev, pager, next"
            :total="1000"
            @current-change="changePage">
          </el-pagination>
        </div>
      </div>

      <el-dialog title="修改开门费用" :visible.sync="editDio" width="600px" class="authDio">
        <div class="form">
        <el-form ref="form" :model="form" label-width="100px">
          <el-form-item label="开门费用">
            <el-input placeholder="输入费用（元）"  v-model="form.formOpenCost"></el-input>
          </el-form-item>
        </el-form>
      </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDio">取消</el-button>
          <el-button type="primary" @click="onSubmit('form')">确定</el-button>
        </span>
      </el-dialog>
  </div>
</template>
<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast } from "../../../../static/js/utility/utility.js"
  import { userApi } from "../../../../static/js/api.js"
  import * as common from "../../../../static/js/common.js"

  export default {
    name: 'COpenLog',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        openCost: null,
        form: {
          formOpenCost: null
        },
        editDio:false,
        openLogList: null
      }
    },
    mounted(){

    },
    created() {
      this.getOpenCost()
    },
    methods: {
      async getOpenCost(){
        this.openCost = (await common.getOpenCost())/100;
        let payLogResult = await common.getOpenLog(1);
        this.openLogList = payLogResult.body;
      },
      async changePage(val) {
        let payLogResult = await common.getOpenLog(val);
        this.openLogList = payLogResult.body;
      },
      openCostDio(){
        this.form.formOpenCost = this.openCost
        this.editDio = true;
      },
      async onSubmit() {
        let that = this;
        let formOpenCost = 100 * parseFloat(this.form.formOpenCost);
        if (formOpenCost === undefined){
          showToast ('请输入开门费用！');
        }
        else {
          // console.log('输入信息: ', formOpenCost);
          let setOpenCostResult = await common.setOpenCost(formOpenCost);
          if (setOpenCostResult !== 200){
            showToast('设置失败!');
          }
          else {
            that.openCost = (await common.getOpenCost())/100;
            showToast('设置成功!');
            that.editDio = false;
          }
        }
      }
    },
    watch: {

    },
  }
</script>
<style lang="scss">
.COpenLog{
  .flex{
    display: flex;
    align-items: center;
  }
  .openCost{
    background: #fff;
    padding: 20px 30px;
    margin: 24px 30px 0;
    .editIcon{
      margin-left: 10px;
      font-size: 20px;
      color: #666;
    }
  }
  .page {
    text-align: center;
    margin-top: 30px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Page/CBsw/COpenLog.vue